export default __webpack_public_path__ + "static/media/MathWallet.0ad0bf1f.svg";